import ProductSelectSearch from './ProductSelectSearch';

export default ProductSelectSearch;